import * as types from "./consultaSolicitacao.actionTypes";

export default {
  consultar: (data) => ({
    type: types.DECA_CONSULTA_SOLICITACAO_GET,
    payload: data,
  }),
};
